// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eruda-dev-tools .eruda-tools .eruda-touches{padding:10px}.eruda-dev-tools .eruda-tools .eruda-touches canvas{display:block;max-height:100%;max-width:100%;background:var(--darker-background);margin:0 auto}", ""]);
// Exports
module.exports = exports;
